/**
 * Keycloak конфигурация
 * URL может быть: https://keycloak.example.com/realms/requiem
 * или базовый: https://keycloak.example.com
 */

import Keycloak from 'keycloak-js';
import { config } from '@/shared/lib/config';

function getKeycloakConfig() {
  const url = config.keycloak.url || 'http://localhost:8080';
  const realm = config.keycloak.realm || 'requiem';
  const baseUrl = url.includes('/realms/') ? url.replace(/\/realms\/.*$/, '') : url;
  return { url: baseUrl, realm, clientId: config.keycloak.clientId };
}

const keycloakInstance = new Keycloak(getKeycloakConfig());

export { keycloakInstance };
